import * as React from "react";
import GeneralSelect from "../../general_select";
import PopDetail from "../../popdetail";
import {ProjectsService} from "../../../service/v1/projects";
import uncheck from "../../../resources/img/checkbox/checkbox_unchecked.png";
import Wait from "../../wait";
import check from "../../../resources/img/checkbox/checkbox_checked.png";
import {BillingService} from "../../../service/v1/billing";
import BillDetailsPane from "../../pane/bill_details_pane";

export default class LandUsePlansPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            project_type: 0,
            description: '',
            zoneOptions: {endpoint: 'localities/list', value: 'id', label: 'name', placeholder: 'Select Zone'},
            regionOptions: {endpoint: 'localities/list', value: 'id', label: 'name', placeholder: 'Select Region'},
            districtOptions: {
                endpoint: 'localities/list',
                value: 'id',
                label: 'name',
                placeholder: 'Select District'
            },
            wardOptions: {
                endpoint: 'localities/list',
                value: 'id',
                label: 'name',
                placeholder: 'Select Ward'
            },
            villageOptions: {
                endpoint: `localities/list`,
                value: 'id',
                label: 'name',
                placeholder: 'Select Village'
            },
            projectOptions: {
                endpoint: `projects/public/project-types`,
                value: 'id',
                label: 'name',
                placeholder: 'Select Land Use Type'
            },
            is_new: 'none',
            is_village: 'none',
            is_ward: 'none',
            is_district: 'none',
            is_regional: 'none',
            is_zonal: 'none',
            is_village_multi: true,
            is_ward_multi: true,
            is_district_multi: true,
            is_regional_multi: true,
            is_zonal_multi: true,
            is_village_disabled: true,
            is_ward_disabled: true,
            is_district_disabled: true,
            is_regional_disabled: true,
            locality: '',
            project_list: {
                endpoint: 'projects/list',
                value: 'id',
                placeholder: 'Select Project',
                label: 'name'
            },
            search_success: 'none',
            projects: [],
            fees: [],
            search_button: 'none', checkout_disabled_btn: 'table-row',
            checkout_enabled_btn: 'none',
            checkout_projects: [],
            index: 0,
            checkout_total: 0,
        }

        this.submit = this.submit.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.generalSelect = this.generalSelect.bind(this)
        this.toggleCheck = this.toggleCheck.bind(this)
        this.checkout = this.checkout.bind(this)
    }


    handleChanges = (e) => {
        this.setState({[e.target.name]: e.target.value})

        console.log(e.target.name)
    }

    generalSelect(data, name) {
        this.setState({
            [name]: data
        })
        console.log(this.state[name])
        console.log("dv : " + data.value)
        let ids = []

        switch (name) {
            case 'zone':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_regional_disabled: false,
                    regionOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Region'
                    },
                    locality: 'Zonal',
                    search_button: 'table-row',
                })
                break;
            case 'region':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_district_disabled: false,
                    districtOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('district_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select District'
                    },
                    locality: 'Regional',
                    search_button: 'table-row',
                })
                break
            case 'district':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_ward_disabled: false,
                    wardOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('ward_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Ward'
                    },
                    locality: 'District',
                    search_button: 'table-row',
                })
                break
            case 'ward':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_village_disabled: false,
                    villageOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('village_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Village'
                    },
                    locality: 'Ward',
                    search_button: 'table-row',
                })
                break
            case 'village':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                }
                this.setState({
                    locality: 'Village',
                    search_button: 'table-row',

                })
                break

            case 'project_type':
                if (data.label.toString().includes('Village') || data.label.toString().includes('CCRO')
                    || data.label.toString().toLowerCase().includes('formal')) {
                    this.setState({
                        is_village: 'table-row',
                        is_ward: 'table-row',
                        is_district: 'table-row',
                        is_ward_multi: false,
                        is_district_multi: false,
                        is_regional_multi: false,
                        is_village_multi: false,
                        is_regional: 'table-row',
                        is_zonal: 'none',
                        regionOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Region'
                        },
                        is_regional_disabled: false,
                        project_type: data.value,
                    })
                }
                if (data.label.toString().includes('District')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'table-row',
                        is_regional: 'table-row',
                        is_regional_multi: false,
                        is_district_multi: false,
                        is_zonal: 'none',
                        regionOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Region'
                        },
                        is_regional_disabled: false,
                        project_type: data.value,
                    })
                }
                if (data.label.toString().includes('Region')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'none',
                        is_regional: 'table-row',
                        is_zonal: 'table-row',
                        is_zonal_multi: false,
                        is_regional_multi: false,
                        zoneOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('zonal_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Zone'
                        },
                        project_type: data.value,
                    })
                }
                if (data.label.toString().includes('Zon')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'none',
                        is_regional: 'none',
                        is_zonal: 'table-row',
                        is_zonal_multi: false,
                        zoneOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('zonal_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Zone'
                        },
                        project_type: data.value,
                    })
                }
                if (data.label.toString().includes('Monitor')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'none',
                        is_regional: 'none',
                        is_zonal: 'table-row',
                        zoneOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('zonal_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Zone'
                        },
                        project_type: data.value,
                    })
                }
                if (data.label.toString().includes('Nation')) {
                    this.setState({
                        locality: 'National',
                        project_type: data.value,
                    })
                }
                break
        }
    }

    resetChecked() {
        this.state.projects.map((d, i) => {
            this.state.fees.map((f, j) => {
                let doc = document.getElementById('chk_' + d.name + '_' + f.name);
                if (doc.src === check)
                    doc.src = uncheck
            })
        })
        this.setState({
            checkout_disabled_btn: 'table-row',
            checkout_enabled_btn: 'none',
            checkout_projects:[],
            checkout_total: 0,
        })
    }

    toggleCheck(project, fee) {
        let doc = document.getElementById('chk_' + project.name + '_' + fee.name);
        try {
            if (doc.src === uncheck) {
                doc.src = check;
                console.log('Size : ' + this.state.checkout_projects.length)
                let project_chk = {'project':project, 'fee': fee}
                this.setState(prevState => {
                    let newProjects = [...prevState.checkout_projects, project_chk];
                    let newCheckoutTotal = prevState.checkout_total + Number(fee.price);
                    //newProjects.push(userId);
                    return {
                        checkout_projects: newProjects, checkout_disabled_btn: 'none',
                        checkout_enabled_btn: 'table-row',
                        checkout_total: newCheckoutTotal
                    };
                });
                console.log('Size 2 : ' + this.state.checkout_projects.length)
                return;
            }
            doc.src = uncheck;
            console.log('Size : ' + this.state.checkout_projects.length)
            this.setState(prevState => {
                let newProjects = prevState.checkout_projects.filter((item) => item.project !== project);
                let newCheckoutTotal = prevState.checkout_total === 0 ? 0 : prevState.checkout_total - Number(fee.price);
                //newProjects.push(userId);
                if (newProjects.length === 0) {
                    return {
                        checkout_projects: newProjects, checkout_disabled_btn: 'table-row',
                        checkout_enabled_btn: 'none',
                        checkout_total: newCheckoutTotal
                    };
                } else {
                    return {
                        checkout_projects: newProjects, checkout_disabled_btn: 'none',
                        checkout_enabled_btn: 'table-row',
                        checkout_total: newCheckoutTotal
                    };
                }
            });
        } catch (e) {
            console.log(e)
        }
    }

    render() {

        return (<div className={'row'}>

            <div className={'col col-sm-12'} style={{padding: 0, height: '100vh', overflow: "auto"}}>


                <table style={{width: '94%', margin: '2%'}}>
                    <tbody>
                    <tr>
                        <td className={'label'} style={{width: '100%'}}>Land Use Type</td>
                    </tr>
                    <tr>
                        <td>
                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'project_type')}
                                           parameters={this.state.projectOptions}/>
                        </td>
                    </tr>

                    <tr>
                        <td style={{width: '100%'}}>
                            <table style={{width: '100%'}}>
                                <tbody>

                                <tr style={{display: this.state.is_zonal}}>
                                    <td colSpan={2} className={'label'}>Zone</td>
                                </tr>
                                <tr style={{display: this.state.is_zonal}}>
                                    <td colSpan={2}>
                                        <GeneralSelect onChanges={(e) => this.generalSelect(e, 'zone')}
                                                       parameters={this.state.zoneOptions}
                                                       isMulti={this.state.is_zonal_multi}/>
                                    </td>
                                </tr>
                                <tr style={{display: this.state.is_regional}}>
                                    <td colSpan={2} className={'label'}>Regions</td>
                                </tr>
                                <tr style={{display: this.state.is_regional}}>
                                    <td colSpan={2}>
                                        <GeneralSelect onChanges={(e) => this.generalSelect(e, 'region')}
                                                       parameters={this.state.regionOptions}
                                                       isMulti={this.state.is_regional_multi}
                                                       isDisable={this.state.is_regional_disabled}/>
                                    </td>
                                </tr>
                                <tr style={{display: this.state.is_district}}>
                                    <td colSpan={2} className={'label'}>District/Council</td>
                                </tr>
                                <tr style={{display: this.state.is_district}}>
                                    <td colSpan={2}>
                                        <GeneralSelect id={'district'}
                                                       onChanges={(e) => this.generalSelect(e, 'district')}
                                                       parameters={this.state.districtOptions}
                                                       isMulti={this.state.is_district_multi}
                                                       isDisable={this.state.is_district_disabled}/>
                                    </td>
                                </tr>

                                <tr style={{display: this.state.is_ward}}>
                                    <td colSpan={2} className={'label'}>Ward</td>
                                </tr>
                                <tr style={{display: this.state.is_ward}}>
                                    <td colSpan={2}>
                                        <GeneralSelect onChanges={(e) => this.generalSelect(e, 'ward')}
                                                       parameters={this.state.wardOptions}
                                                       isMulti={this.state.is_ward_multi}
                                                       isDisable={this.state.is_ward_disabled}/>
                                    </td>
                                </tr>

                                <tr style={{display: this.state.is_village}}>
                                    <td colSpan={2} className={'label'}>Villages</td>
                                </tr>
                                <tr style={{display: this.state.is_village}}>
                                    <td colSpan={2}>
                                        <GeneralSelect onChanges={(e) => this.generalSelect(e, 'village')}
                                                       parameters={this.state.villageOptions}
                                                       isMulti={this.state.is_village_multi}
                                                       isDisable={this.state.is_village_disabled}/>
                                    </td>
                                </tr>

                                </tbody>
                            </table>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div style={{display: this.state.search_button, textAlign: 'center', width: '98%', float: 'left'}}>
                    <button className={'btn submit'} onClick={this.submit}>
                        <span className={'fa fa-search'}/>Search Land Use
                    </button>
                </div>


                <div className={"row"} style={{width: '94%', margin: '2%'}}>
                    <div style={{
                        display: this.state.search_success,
                        overflowX: 'hidden',
                        overflowY: 'auto',
                        width: '98%'
                    }} className={'col col-sm-12'}>
                        <table className={'tb'} style={{margin: '1%', width: '99%'}}>
                            <thead>
                            <tr>
                                <th>No.</th>
                                <th style={{position: 'sticky', lcheckout_totaleft: 0, zIndex: 2}}>Land Use Name</th>
                                <th>Published Date</th>
                                <th>Document Type</th>
                                <th>Price</th>
                                <th>Currency</th>
                                <th>Selected</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.projects.map((d, i) => {
                                    return (
                                        this.state.fees.map((f, j) => {
                                                var price = Number(f.price);
                                                price = price.toLocaleString('en-US', {maximumFractionDigits:2})
                                                return (<tr key={2*i + j + i}>
                                                    <td>{2*i + j + i + 1}</td>
                                                    <td>
                                                        <span style={{color: 'darkcyan'}}>{d.name}</span>
                                                    </td>
                                                    <td>{d.published_date}</td>
                                                    <td>{f.name}</td>
                                                    <td>{price}</td>
                                                    <td>{f.currency_name}</td>
                                                    <td style={{
                                                        textAlign: 'center',
                                                        backgroundColor: 'white',
                                                        width: '5%'
                                                    }}>
                                                        <img id={'chk_' + d.name + '_' + f.name} alt={'chk_' + d.name + '_' + f.name} src={uncheck}
                                                             onClick={() => this.toggleCheck(d, f)}/>
                                                    </td>
                                                </tr>)
                                            }
                                        )
                                    )
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className={"row"} style={{width: '98%', margin: '2%'}}>
                    <div className={'col col-sm-2'}></div>
                    <div style={{
                        display: this.state.checkout_enabled_btn,
                        overflowX: 'hidden',
                        overflowY: 'auto',
                        border: 'lightgray',
                        backgroundColor: 'whitesmoke',
                        borderStyle: 'dashed',
                        marginLeft: '2%',
                    }} className={'col col-sm-6'}>
                        <br/>
                        <center className={"row"} style={{fontSize: '17px', padding: '10px', paddingTop: '15px'}}>
                            <b>Purchase List</b></center>
                        {
                            this.state.checkout_projects.map((d, i) => {
                                var price = Number(d.fee.price);
                                price = price.toLocaleString('en-US', {maximumFractionDigits:2})
                                return (<div>
                                    <div style={{padding: '5px', fontSize: '16px'}} className={"row"} key={i}>
                                        <div className={'col col-sm-2'}></div>
                                        <div className={'col col-sm-1'}>
                                            <span>{i + 1 + '.'}</span>
                                        </div>
                                        <div className={'col col-sm-5'}>
                                            <span>{d.project.name + ' - ' + d.fee.name}</span>
                                        </div>
                                        <div className={'col col-sm-2'}>
                                            <span>{price}</span>
                                        </div>
                                    </div>
                                </div>)
                            })
                        }

                        <center style={{
                            borderTop: 'lightgray',
                            borderBottom: 'whitesmoke',
                            borderLeft: 'whitesmoke',
                            borderRight: 'whitesmoke',
                            borderStyle: 'dashed',
                            marginLeft: '18%',
                            marginRight: '18%'
                        }} className={"row"}></center>

                        <div style={{padding: '5px', fontSize: '16px'}} className={"row"}>
                            <div className={'col col-sm-3'}></div>
                            <div className={'col col-sm-5'} style={{textAlign: 'center'}}>
                                <span><b>Total</b></span>
                            </div>
                            <div className={'col col-sm-2'}>
                                <span><b>{this.state.checkout_total.toLocaleString()}</b></span>
                            </div>
                        </div>
                        <center className={"row"} style={{width: '98%', marginBottom: '1%', paddingTop: '5%'}}>
                            <div className={"col col-sm-5"}></div>
                            <div className={"col col-sm-3"}>
                                <button className={'btn'} onClick={this.checkout} disabled={false}
                                        style={{
                                            display: this.state.checkout_enabled_btn,
                                            backgroundColor: '#0099cc',
                                            width: "fit-content"
                                        }}>
                                    <span className={'fa fa-shopping-cart fa-lg'}/>Generate Bill
                                </button>
                            </div>
                            <div className={"col col-sm-5"}></div>
                        </center>
                        {/*</div>*/}

                    </div>

                </div>

                <div className={"row"} style={{width: '98%', margin: '5%'}}></div>

            </div>

        </div>)
    }

    submit() {
        try {

            let locality

            switch (this.state.locality) {
                case 'Village':
                    locality = this.state.village
                    break
                case 'Ward':
                    locality = this.state.ward
                    break
                case 'District':
                    locality = this.state.district
                    break
                case 'Regional':
                    locality = this.state.region
                    break
                case 'Zonal':
                    locality = this.state.zone
                    break
                case 'National':
                    locality.push(sessionStorage.getItem('national_level_id'))
                    break
            }
            console.log(locality.value)

            Wait.show('Searching Land Uses...')
            ProjectsService.fetchPublishedProjects(locality.value).then(r => {
                Wait.dismiss()
                try {
                    this.setState({
                        projects: r.data.results,
                        totalPages: r.data.count,
                        next: r.data.next,
                        previous: r.data.previous,
                        search_success: 'table-row'
                    })
                    this.resetChecked()
                } catch (e) {
                    console.log(e)
                }
            })

            BillingService.fetchFees(this.state.project_type).then(r => {
                try {
                    this.setState({
                        fees: r.data.results,
                    })
                } catch (e) {
                    console.log(e)
                }
            })

        } catch (e) {
            alert(e)
        }
    }

    checkout() {
        try {
            let checkout_projects = []
            this.state.checkout_projects.forEach(it => {
                console.log("REF : " + it.project.name)
                checkout_projects.push(it)
            })

            console.log('Check Total : ' + this.state.checkout_total)
            PopDetail.show('Bill Details', <BillDetailsPane
                projects={checkout_projects}
                checkout_total={this.state.checkout_total}
                key={new Date().getMilliseconds()}/>, 80)

            //this.resetChecked()

            /* ProjectsService.createProject({
                 name: name,
                 description: desc,
                 locality_ids: locality,
                 project_type: project_type,
                 project: project,
                 funder_ids: project_funder,
                 budget: budget,
                 reg_date: '',
             }).then(r => {
                 this.props.loadProjects()
                 PopDetail.dismiss()
             })*/

        } catch (e) {
            alert(e)
        }
    }

}